import { createReducer, on } from '@ngrx/store';
import { updateConfirmPassword, updatePassword } from './passwords_form_actions_creator';
import { initialPasswordFormState } from './passwords_form_state';

export const changePasswordReducer = createReducer(
  initialPasswordFormState,
  on(updatePassword, (state, action) => ({...state, password: action.password})),
  on(updateConfirmPassword, (state, action) => ({...state, confirmPassword: action.confirmPassword}))
);
